import ArchivePage from './ArchivePage';
export default {
    path: '/archive',
    component: ArchivePage,
};
